import React from 'react';
export const ErrorMessage = ({ error }) => {
    if (!error)
        return null;
    return (<span>
      <p className="validation-invalid">{error.message}</p>
    </span>);
};
